
<div>
    <c-list-card
        :background = "background"
        :edit       = "false"
        :height     = "155"
        @selected   = "onSelected"
    >
        <template v-slot:toolbar>
            <div style="margin-top: -3px;">
                <c-toolbar-button
                    v-if   ="item.documentId"
                    icon   = "mdi-file-pdf-box-outline"
                    size   = "22"
                    color  = "primary"
                    @click = "onDocument"
                />
            </div>
        </template>

        <template v-slot:title>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        class  = "maintenance-title"
                    >
                        {{ format (item.dateAssessment) }} - {{ item.type.name }}
                    </div>
                </template>

                <div >
                    {{ format (item.dateAssessment) }} - {{ item.type.name }}
                </div>
            </v-tooltip>
        </template>

        <template v-slot:subtitle>
            <span>{{ item.company.name }}</span>
            <span> - </span>
            <span>{{ item.status.name }}</span>
        </template>

        <template v-slot:body>
                <v-row class="no-frame mt-1">
                    <v-col class="no-frame">
                        {{ $t('inc.assessment.result') }}
                    </v-col>
                    <v-col class="no-frame">
                        {{ item.result ? item.result.name : na }}
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        {{ $t('inb.detail.assessment.dateNext') }}
                    </v-col>
                    <v-col class="no-frame">
                        {{ format(item.dateNextAssessment) }}
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        {{ $t('inb.detail.assessment.dateRemedy') }}
                    </v-col>
                    <v-col class="no-frame">
                        {{ format(item.dateRemedyOfDefects) }}
                    </v-col>
                </v-row>
        </template>

        <template v-slot:footer>
            {{ item.reporter }}
        </template>

    </c-list-card>
</div>
